/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Represents whether or not a tutor has been successfully paid for a meeting
 */
export enum MeetingTutorPaymentStatus {
  TUTOR_PAID = "TUTOR_PAID",
  NO_PAYMENT_APPLIES = "NO_PAYMENT_APPLIES",
  PAYMENT_QUEUED = "PAYMENT_QUEUED",
  TUTOR_PAYMENT_FAILED = "TUTOR_PAYMENT_FAILED",
  TUTOR_NOT_PAID = "TUTOR_NOT_PAID",
}
